module.exports = __webpack_public_path__ + "img/charm_7.81859f51.png";